export default {
  'pet-profile:page:title': 'Mein Profil',
  'pet-profile:header:title': '<p>Eine</p> <p>Persönliche</p> <p>Auswahl</p>',
  'pet-profile:display:not-chosen': 'Nicht gewählt',
  'pet-profile:display:breed-not-chosen': '+ Rasse hinzufügen',
  'pet-profile:display:weight-not-chosen': '+ Gewicht hinzufügen',
  'pet-profile:display:age-not-chosen': '+ Alter hinzufügen',
  'pet-profile:display:needs-not-chosen': '+ Bedürfnis hinzufügen',
  'pet-profile:display:food-type-not-chosen': '+ Futtertyp hinzufügen',
  'pet-profile:display:your-pet': 'Für Deinen Hund',
  'pet-profile:display:edit': 'Bearbeiten',
  'pet-profile:display:edit-your-pet-profile': 'Bearbeite dein persönliches Profil',
  'pet-profile:display:edit-your-pet-profile:title:empty':
    'Erstelle ein Profil für deinen Vierbeiner',
  'pet-profile:display:edit-your-pet-profile:title:filled': 'Profil bearbeiten',
  'pet-profile:display:edit-your-pet-profile:subtitle':
    'Für gezielte Produktempfehlungen, die wirklich passen!',
  'pet-profile:display:food-preference': 'Futtermittelpräferenz',
  'pet-profile:cdp:title': 'Wau! Empfehlungen - abgestimmt auf eure Bedürfnisse',
  'pet-profile:cdp:title:cat': 'Empfehlungen für Deine Katze',
  'pet-profile:no-petprofile-page:title': 'Individuelle Produktempfehlung in 3, 2, 1 …!',
  'pet-profile:no-petprofile-page:text': `Verrate uns Alter, Rasse und die besonderen Bedürfnisse deines Lieblings und erhalte eine persönliche Produktauswahl von uns. {br}
        {br}
        Du hast bereits bei uns bestellt? Dann logge dich in deinen bestehenden Account ein.`,
  'pet-profile:no-petprofile-page:start': 'Futterempfehlung erstellen',
  'pet-profile:no-petprofile-page:login': 'Jetzt einloggen',
  'pet-profile:header:your-pet': 'Dein Vierbeiner',
  'pet-profile:header:add-profile': 'Weiteres Profil anlegen',
  'pet-profile:placeholder:dog-name': 'Dein Vierbeiner',
  'pet-profile:segmentation-update-sheet:weight-error':
    'Gewicht muss zwischen {min} und {max} kg liegen',
  'pet-profile:segmentation-update-sheet:name:placeholder': 'Name eingeben',
  'pet-profile:guide-change-pet-description': 'Hier kannst du zwischen deinen Profilen wechseln',
  'pet-profile:guide-edit-description':
    'Für ein besseres Erlebnis – gib deinem Vierbeiner einen Namen!',
  'pet-profile:segmentation-update-sheet:delete-profile:button': 'Dieses Profil löschen',
  'pet-profile:segmentation-update-sheet:delete-profile:title': 'Bist du sicher?',
  'pet-profile:segmentation-update-sheet:delete-profile:text:with-pet-name':
    'Bist du sicher, dass du {petName} Profil löschen möchtest? Diese Aktion lässt sich nicht rückgängig machen.',
  'pet-profile:segmentation-update-sheet:delete-profile:text:without-pet-name':
    'Bist du sicher, dass du dein persönliches Profil löschen möchtest? Diese Aktion lässt sich nicht rückgängig machen.',
  'pet-profile:segmentation-update-sheet:delete-profile:confirm': 'Ja, löschen',
  'pet-profile:segmentation-update-sheet:delete-profile:cancel': 'Abbrechen',
  'pet-profile:error:duplicate-name': 'Du hast bereits ein bestehendes Profil mit diesem Namen.',
  'pet-profile:error:name-required': 'Bitte gib einen Namen ein.',

  'pet-profile:feed-type-selector:title': 'Futterart & Konsistenz',
  'pet-profile:feed-type-selector:wet_food': 'Nassfutter',
  'pet-profile:feed-type-selector:dry_food': 'Trockenfutter',
  'pet-profile:feed-type-selector:snacks': 'Snacks',
  'pet-profile:feed-type-selector:barf': 'BARF',
  'pet-profile:feed-type-selector:wet_food:sauce': 'Sauce',
  'pet-profile:feed-type-selector:wet_food:pate': 'Pate',
  'pet-profile:feed-type-selector:wet_food:cream': 'Cream',
  'pet-profile:feed-type-selector:wet_food:description:sauce': 'Saucen Menü, Juicy Filet',
  'pet-profile:feed-type-selector:wet_food:description:pate': 'Pure Meat, Filet Menü, Meaty Pate',
  'pet-profile:feed-type-selector:wet_food:description:cream': 'Silky Cream',
  'pet-profile:feed-type-selector:consistency-title': 'Konsistenz',
  'pet-profile:feed-type-selector:consistency:sauce': 'Saucen',
  'pet-profile:feed-type-selector:consistency:pate': 'Pate',
  'pet-profile:feed-type-selector:consistency:cream': 'Cream',
  'pet-profile:feed-type-selector:consistency:sauce:saucen-menu': 'Saucen Menü',
  'pet-profile:feed-type-selector:consistency:sauce:juicyfilets': 'Juicy Filet',
  'pet-profile:feed-type-selector:consistency:pate:puremeat': 'Pure Meat',
  'pet-profile:feed-type-selector:consistency:pate:filet-menu': 'Filet Menü',
  'pet-profile:feed-type-selector:consistency:pate:meatypate': 'Meaty Pate',
  'pet-profile:feed-type-selector:consistency:cream:silkycream': 'Silky Cream',
  'pet-profile:feed-type-selector:consistency:all': 'Alle Konsistenzen',

  'pet-profile:taste-selector:title': 'Bevorzugte Geschmacksrichtung',
  'pet-profile:taste-selector:description':
    'Wähle die Geschmacksrichtung, die deiner Samtpfote am besten schmeckt',
  'pet-profile:protein-preference-selector:title': 'Geschmacksrichtungen',
  'pet-profile:protein-preference-selector:description':
    'Sag uns für jede Sorte, ob deine Katze sie mag, nicht mag oder neutral findet.',
  'pet-profile:protein-preference-selector:state:dislike': 'Mag ich nicht',
  'pet-profile:protein-preference-selector:state:neutral': 'Neutral',
  'pet-profile:protein-preference-selector:state:like': 'Mag ich',
  'pet-profile:protein-preference-selector:choice:dislike': 'Mag ich nicht',
  'pet-profile:protein-preference-selector:choice:neutral': 'Neutral',
  'pet-profile:protein-preference-selector:choice:like': 'Mag ich',
  'pet-profile:no-pet-profile:title:dog': 'Suchst du das Profil deines Hundes?',
  'pet-profile:no-pet-profile:title:cat': 'Suchst du das Profil deiner Katze?',
  'pet-profile:no-pet-profile:title:name': 'Suchst du {name} Profil?',

  'pet-profile:snack-slider:headline:with-name': 'Die perfekte Ergänzung für {name}',
  'pet-profile:snack-slider:headline:with-breed': 'Die perfekte Ergänzung für {breed}',
  'pet-profile:snack-slider:headline:with-pet-type':
    'Die perfekte Ergänzung für {petType, select, cat {deine Katze} other {deinen Hund}}',

  'pet-profile:empty-collection:title': 'Kein passendes Produkt verfügbar',
  'pet-profile:empty-collection:description':
    'Bitte reduziere die Anzahl der ausgewählten Filter, um Produkte angezeigt zu bekommen.',
  'pet-profile:empty-collection:image-alt': 'Keine passenden Produkte gefunden',

  'pet-profile:empty-profile:title': 'Futter, das wirklich passt',
  'pet-profile:empty-profile:description':
    'Erstelle ein Profil für deinen Hund oder deine Katze. Anhand von Alter, Rasse und Bedürfnissen empfehlen wir passendes Futter.',
  'pet-profile:empty-profile:cta': 'Profil erstellen',
  'pet-profile:empty-profile:image-alt': 'Hund und Katze mit Futternapf',

  'pet-profile:calorie-calculator:title': 'Fütterungsrechner',
  'pet-profile:calorie-calculator:subtitle':
    'In einer Minute die optimale tägliche Futtermenge für deinen Vierbeiner berechnen',
  'pet-profile:calorie-calculator:product-page-hint':
    'Wie lange das Futter reicht, rechnen wir dir auf der Produktseite aus. Passe dazu einfach die Variante und Menge an.',
  'pet-profile:calorie-calculator:back-to-product': 'Zum Produkt',
  'pet-profile:calorie-calculator:start-calculation': 'Berechnung starten',
  'pet-profile:calorie-calculator:requires-support:young-dog':
    'Doggos unter 3 Monaten brauchen eine individuelle Beratung. Bitte wende dich an unsere Ernährungsexperten.',
  'pet-profile:calorie-calculator:requires-support:young-cat':
    'Miezen unter 7 Wochen brauchen eine individuelle Beratung. Bitte wende dich an unsere Ernährungsexperten.',
  'pet-profile:calorie-calculator:requires-support:dog':
    'Doggos mit speziellen Bedürfnissen brauchen eine individuelle Beratung. Bitte wende dich an unsere Ernährungsexperten.',
  'pet-profile:calorie-calculator:requires-support:cat':
    'Katzen mit speziellen Bedürfnissen brauchen eine individuelle Beratung. Bitte wende dich an unsere Ernährungsexperten.',
  'pet-profile:calorie-calculator:kcal-per-day': 'Kcal / Tag',
  'pet-profile:calorie-calculator:grams-per-day': 'Gramm / Tag',
  'pet-profile:calorie-calculator:consultation':
    'Eine individuelle Beratung mit unseren Ernährungsexperten kannst du <link>hier</link> vereinbaren.',
  'pet-profile:calorie-calculator:next': 'Weiter',
  'pet-profile:calorie-calculator:yes': 'Ja',
  'pet-profile:calorie-calculator:no': 'Nein',
  'pet-profile:calorie-calculator:days-per-pack:start': 'Futtermenge berechnen',
  'pet-profile:calorie-calculator:days-per-pack:requires-support':
    'Wir können den täglichen Kalorienbedarf aufgrund spezieller Bedürfnisse nicht berechnen. Eine individuelle Beratung mit unseren Ernährungsexperten kannst du <link>hier</link> buchen.',
  'pet-profile:calorie-calculator:days-per-pack:coverage':
    'Die ausgewählte Variante & Menge deckt den Bedarf von <strong>{totalDays} {totalDays, plural, one {Tag} other {Tagen}}</strong>.',
  'pet-profile:calorie-calculator:wizard:loading':
    'Jetzt wird gerechnet – deine Futterempfehlung in 3, 2, 1…',
  'pet-profile:calorie-calculator:wizard:date-of-birth:title:dog': 'Wann wurde dein Doggo geboren?',
  'pet-profile:calorie-calculator:wizard:date-of-birth:title:cat':
    'Wann wurde deine Katze geboren?',
  'pet-profile:calorie-calculator:wizard:breed:title':
    'Welche Rasse beschreibt deinen Doggo am besten?',
  'pet-profile:calorie-calculator:wizard:breed:hint':
    'Die Rasse verrät viel über Energielevel & Stoffwechsel. Das hilft uns, die richtige Menge zu finden.',
  'pet-profile:calorie-calculator:wizard:weight:title': 'Wie viel wiegt dein Vierbeiner aktuell?',
  'pet-profile:calorie-calculator:wizard:special-needs:title': 'Gibt es etwas zu beachten, wie...',
  'pet-profile:calorie-calculator:wizard:special-needs:description:dog':
    'Krankheiten, Trächtigkeit, Laktation oder eine kürzliche Operation können die Ernährungsbedürfnisse deines Hundes beeinflussen. Trifft einer dieser Punkte auf deinen Vierbeiner zu?',
  'pet-profile:calorie-calculator:wizard:special-needs:description:cat':
    'Krankheiten, Trächtigkeit, Laktation oder eine kürzliche Operation können die Ernährungsbedürfnisse deiner Katze beeinflussen. Trifft einer dieser Punkte auf deine Katze zu?',
  'pet-profile:calorie-calculator:wizard:sterilized:title:dog':
    'Ist dein Doggo kastriert bzw. sterilisiert?',
  'pet-profile:calorie-calculator:wizard:sterilized:title:cat':
    'Ist deine Katze kastriert bzw. sterilisiert?',
  'pet-profile:calorie-calculator:wizard:sterilized:hint:dog':
    'Nach einer Kastration verbrauchen viele Doggos weniger Energie – deshalb ist dieser Schritt für die Berechnung so wichtig',
  'pet-profile:calorie-calculator:wizard:sterilized:hint:cat':
    'Nach einer Kastration verbrauchen viele Katzen weniger Energie – deshalb ist dieser Schritt für die Berechnung so wichtig',
  'pet-profile:calorie-calculator:wizard:body-condition:title': 'Zeit für einen Body-Check!',
  'pet-profile:calorie-calculator:wizard:body-condition:description':
    'Achte besonders auf Taille, Rippen und Gesamterscheinung – so findest du die passende Einschätzung für deinen Vierbeiner.',
  'pet-profile:calorie-calculator:wizard:body-condition:very-lean:title': 'Sehr schlank',
  'pet-profile:calorie-calculator:wizard:body-condition:very-lean:description':
    'Rippen gut sichtbar',
  'pet-profile:calorie-calculator:wizard:body-condition:slightly-lean:title': 'Etwas zu schlank',
  'pet-profile:calorie-calculator:wizard:body-condition:slightly-lean:description':
    'Taille klar erkennbar',
  'pet-profile:calorie-calculator:wizard:body-condition:ideal:title': 'Ideal in Form',
  'pet-profile:calorie-calculator:wizard:body-condition:ideal:description': 'Rippen leicht tastbar',
  'pet-profile:calorie-calculator:wizard:body-condition:slightly-rounded:title': 'Etwas rundlich',
  'pet-profile:calorie-calculator:wizard:body-condition:slightly-rounded:description':
    'Wenig Taille sichtbar',
  'pet-profile:calorie-calculator:wizard:body-condition:well-padded:title': 'Gut gepolstert',
  'pet-profile:calorie-calculator:wizard:body-condition:well-padded:description':
    'Bauch hängend / keine Taille',
  'pet-profile:calorie-calculator:wizard:activity-level:title:cat': 'Wie aktiv ist deine Mieze?',
  'pet-profile:calorie-calculator:wizard:activity-level:title:dog': 'Wie aktiv ist dein Doggo?',
  'pet-profile:calorie-calculator:wizard:activity-level:low:title': 'Indoor / Low',
  'pet-profile:calorie-calculator:wizard:activity-level:low:description:cat':
    'Für Katzen mit einem ruhigen Alltag in Wohnungshaltung. Sie bewegen sich wenig und haben eher kurze, entspannte Spielphasen',
  'pet-profile:calorie-calculator:wizard:activity-level:low:description:dog':
    'Bis zu ca. 1 Stunde gemütliches Spazierengehen pro Tag, ergänzt durch gelegentliches Spielen (z. B. zuhause)',
  'pet-profile:calorie-calculator:wizard:activity-level:medium:title': 'Indoor / Gering',
  'pet-profile:calorie-calculator:wizard:activity-level:medium:description:cat':
    'Für Wohnungskatzen mit einem aktiven Alltag. Regelmäßiges Spielen, Klettern und Bewegung gehören fest zu ihrem Tagesablauf',
  'pet-profile:calorie-calculator:wizard:activity-level:medium:description:dog':
    'Ca. 1–2 Stunden Bewegung täglich – zwischendurch auch mit Rennen, Ballspielen oder ähnlichen Aktivitäten',
  'pet-profile:calorie-calculator:wizard:activity-level:high:title': 'Outdoor / Aktiv',
  'pet-profile:calorie-calculator:wizard:activity-level:high:description:cat':
    'Für Katzen mit freiem Zugang nach draußen. Sie sind viel in Bewegung, erkunden ihr Revier und legen dabei auch längere Strecken zurück',
  'pet-profile:calorie-calculator:wizard:activity-level:high:description:dog':
    'Mehr als 2 Stunden intensive Bewegung im Freien pro Tag und/oder regelmäßiger Hobbysport (z. B. Joggen, Agility o. Ä.)',
  'pet-profile:calorie-calculator:wizard:support:title:special-needs:cat':
    'Wir kümmern uns um die Bedürfnisse deiner Mieze',
  'pet-profile:calorie-calculator:wizard:support:title:special-needs:dog':
    'Wir kümmern uns um die besonderen Bedürfnisse deines Hundes',
  'pet-profile:calorie-calculator:wizard:support:title:young-dog':
    'Kleine Hunde, große Verantwortung',
  'pet-profile:calorie-calculator:wizard:support:title:young-cat':
    'Kleine Miezen, großen Verantwortung',
  'pet-profile:calorie-calculator:wizard:support:description:young-dog':
    'Junge Welpen wachsen rasant und benötigen eine Ernährung, die genau auf sie abgestimmt ist. Deshalb nehmen wir uns gerne persönlich Zeit für eine individuelle Beratung – damit dein Doggo von Anfang an die optimale Unterstützung bekommt, die er braucht.',
  'pet-profile:calorie-calculator:wizard:support:description:young-cat':
    'Junge Kitten wachsen rasant und benötigen eine Ernährung, die genau auf sie abgestimmt ist. Deshalb nehmen wir uns gerne persönlich Zeit für eine individuelle Beratung – damit deine Miezekatz von Anfang an die optimale Unterstützung bekommt, die sie braucht.',
  'pet-profile:calorie-calculator:wizard:support:description:special-needs:dog':
    'Damit dein Hund optimal versorgt ist, empfehlen wir eine persönliche, kostenlose Beratung. So erstellen wir einen Fütterungsplan, der perfekt zu seinen individuellen Bedürfnissen passt.',
  'pet-profile:calorie-calculator:wizard:support:description:special-needs:cat':
    'Damit deine Mieze optimal versorgt ist, empfehlen wir eine persönliche, kostenlose Beratung. So erstellen wir einen Fütterungsplan, der perfekt zu ihren individuellen Bedürfnissen passt.',
  'pet-profile:calorie-calculator:wizard:support:cta': 'Kostenlose Beratung vereinbaren',
  'pet-profile:calorie-calculator:wizard:support:go-back': 'Zurück zu den Fragen',
  'pet-profile:avatar:image-alt': 'Bild eines {petType}',
};
